// extracted by mini-css-extract-plugin
export default {"directionButton":"directionButton_directionButton__Rt+tZ","next":"directionButton_next__d4WkH","prev":"directionButton_prev__jkVz-"};